<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  name: "line-chart",
  mixins: [reactiveProp],
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              drawOnChartArea: false
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              drawOnChartArea: false
            }
          }
        ]
      },
      plugins: {
        datalabels: {
          color: "#ffffff",
          // eslint-disable-next-line no-unused-vars
          formatter: (value, context) => {
            return "";
          }
        },
        deferred: {
          xOffset: 150,
          yOffset: "50%",
          delay: 500
        }
      },
      legend: {
        display: true
      }
    },
    chartStyles: {
      height: `300px`
    }
  }),
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
